// extracted by mini-css-extract-plugin
export default {"productDescription":"i--z","featuredDescription":"j--z","description":"k--z","more":"l--z","descriptionSku":"m--z"};